import { normalize } from 'normalizr'

import mixpanel, { EVENTS } from 'services/mix-panel'
import schema from './schema'

export const FETCHED_ALL = 'PET_PARENTS/FETCHED_ALL'
export const FETCHED_ONE = 'PET_PARENTS/FETCHED_ONE'
export const UPDATE = 'PET_PARENTS/UPDATE'
export const ADD = 'PET_PARENTS/ADD'
export const REMOVE = 'PET_PARENTS/REMOVE'

export function addPetParent(petId, data) {
  return async (dispatch, getState, api) => {
    const response = await api.petParents.create(petId, data)

    mixpanel.track(EVENTS.PET_ADDED)

    dispatch({
      type: ADD,
      payload: normalize(response, schema),
    })
    return response
  }
}

export function removePetParent(petId) {
  return async (dispatch, getState, api) => {
    const response = await api.petParents.remove(petId)
    
    // The DELETE operation returns the number of deleted records
    // We need to dispatch the REMOVE action with the petId
    dispatch({
      type: REMOVE,
      payload: { result: petId },
    })
    
    return response
  }
}

export function verifyEmailOtp(petId, data) {
  return async (dispatch, getState, api) => {
    const response = await api.petParents.verifyEmailOtp(petId, data)
    return response
  }
}

export function verifyPhoneOtp(petId, data) {
  return async (dispatch, getState, api) => {
    const response = await api.petParents.verifyPhoneOtp(petId, data)
    return response
  }
}

export function resendEmailOtp(petId) {
  return async (dispatch, getState, api) => {
    const response = await api.petParents.resendEmailOtp(petId)
    return response
  }
}

export function resendPhoneOtp(petId) {
  return async (dispatch, getState, api) => {
    const response = await api.petParents.resendPhoneOtp(petId)
    return response
  }
}